export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14598.0ffc2bec.jpg";